<template>
<v-autocomplete
  v-model="select"
  :items="items"
  :loading="loading"
  :search-input.sync="search"
  hide-no-data
  no-filter
  return-object

  :menu-props="{ offsetY: true, fixed: true }"
  :label="$t('Standort')"
  :placeholder="placeholder"

  no-data-text="Keine passenden Orte gefunden"
  attach
  @change="change"
  filled

  clearable
></v-autocomplete>
</template>

<script>
import { GeocoderFactory } from "./Geocoder";

export default {
  name: "GeocoderAutocomplete",

  props: [
    "value",
    "placeholder",
    "hide-details"
  ],

  data() {
    return {
      loading: false,
      search: null,
      select: null,
      items: []
    };
  },

  created() {
    this.timer = null;
    this.seq = 0;
    this.geocoder = null;
    this.geocoderPromise = GeocoderFactory().then(geocoder => {
      this.geocoder = geocoder;
      return geocoder;
    });
  },

  beforeDestroy() {
    this.abortPending();
    this.items = [];
  },

  watch: {
    search(val) {
      if (!val) {
        this.abortPending();
        this.items = [];
        return;
      }

      if (val === this.select || (this.select && val === this.select.text)) {
        return;
      }

      this.querySelections(val);
    },

    value(val) {
      if (val) {
        this.select = val;
      }
    }
  },

  methods: {
    abortPending() {
      if (this.timer != null) {
        clearTimeout(this.timer);
        this.timer = null;
      }

      this.seq++;

      if (this.geocoder) {
        this.geocoder.cancelAutocomplete();
      }

      this.loading = false;
    },

    querySelections(value) {
      this.abortPending();

      const seq = this.seq;
      this.loading = true;

      this.timer = setTimeout(() => {
        this.timer = null;

        this.geocoderPromise.then(geocoder => {
          if (seq !== this.seq) {
            return null;
          }
          return geocoder.autocomplete(value);
        }).then(items => {
          if (seq !== this.seq || !items) {
            return;
          }
          this.items = items.slice();
        }, () => {
          if (seq === this.seq) {
            this.items = [];
          }
        }).then(() => {
          if (seq === this.seq) {
            this.loading = false;
          }
        });
      }, 150);
    },

    change(o) {
      this.abortPending();
      this.$emit("change", o);
    }
  }
};
</script>
